/* istanbul ignore file */
export * from './SampleOrderCtA';
